module.exports = __webpack_public_path__ + "static/media/how_ko.2276ecbe.vtt";